var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
import filterReactProps from "filter-react-props";
import { styled } from "../imports";
import { prop, spaceProp } from "../utils";
import { sizeProps, overflowProps, flexGap, flexContainerProps, flexItemProps } from "../props";
import Box from "./Box";
var WrapperBox = function WrapperBox(_ref) {
  var _ref$is = _ref.is,
    Component = _ref$is === undefined ? "div" : _ref$is,
    width = _ref.width,
    height = _ref.height,
    innerStyle = _ref.innerStyle,
    innerRef = _ref.innerRef,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["is", "width", "height", "innerStyle", "innerRef", "children"]);
  return React.createElement("div", _extends({}, filterReactProps(props), {
    ref: innerRef
  }), React.createElement(Component, {
    style: innerStyle
  }, children));
};
var Flex = /*#__PURE__*/styled(WrapperBox, {
  label: "Flex",
  target: "css-1sm44w70"
})(prop("inline", "display:inline-block"), ";", sizeProps, ";", overflowProps, ";>:first-child{min-width:inherit;width:inherit;max-width:inherit;min-height:inherit;height:inherit;max-height:inherit;", flexContainerProps, ";", spaceProp(flexGap), ";}");
Flex.displayName = "Flex";
Flex.Item = /*#__PURE__*/styled(Box, {
  target: "css-1sm44w71"
})(sizeProps, ";", flexItemProps, ";");
Flex.Item.displayName = "Flex.Item";
export default Flex;